var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 127,
    fill: "none",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003E6B",
    stroke: "#003E6B",
    d: "M5 .5h121.5v126H5c-2.485 0-4.5-2.015-4.5-4.5V5C.5 2.515 2.515.5 5 .5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED3431",
    d: "M71.015 99c-2.053 0-4.023-.815-5.475-2.265l-1.04-1.04-1.04 1.04C62.008 98.185 60.038 99 57.985 99c-3.853 0-7.121-2.83-7.665-6.642l-.203-1.422c-.328-2.292-1.266-4.455-2.713-6.262C44.553 81.114 43 76.691 43 72.131 43 65.983 47.988 61 54.142 61h1.086c3.727 0 7.205 1.86 9.272 4.957C66.567 62.86 70.045 61 73.772 61h1.086C81.012 61 86 65.983 86 72.13c0 4.56-1.553 8.984-4.404 12.544-1.447 1.807-2.385 3.97-2.713 6.262l-.203 1.422C78.136 96.17 74.868 99 71.015 99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#84BE60",
    fillRule: "evenodd",
    d: "M64.677 66.085c.908 0 1.644-.735 1.644-1.643v-1.645c.01-4.104 1.714-7.996 4.666-10.78.66-.621.813-1.644.269-2.369-.546-.727-1.585-.879-2.258-.268-2.338 2.12-4.066 4.797-5.044 7.75-1.63-4.372-5.844-7.485-10.785-7.485h-3.288c0 6.355 5.152 11.508 11.508 11.508h1.723c-.051.544-.078 1.093-.079 1.644v1.645c0 .908.736 1.644 1.644 1.644z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0063C3",
    d: "M105 99H21c-.552 0-1 .448-1 1v11c0 .552.448 1 1 1h84c.552 0 1-.448 1-1v-11c0-.552-.448-1-1-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#66A1DB",
    d: "M28.508 98.967H25.22v13.152h3.288V98.967zM35.085 98.966h-3.288v13.152h3.288V98.966zM94.27 98.966h-3.288v13.152h3.288V98.966zM100.846 98.966h-3.288v13.152h3.288V98.966zM48.237 103.898H41.66v3.289h6.576v-3.289zM63.033 103.898H51.525v3.289h11.508v-3.289zM69.61 103.898H66.32v3.289h3.288v-3.289zM84.406 103.898H72.898v3.289h11.508v-3.289z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F48583",
    d: "M57.33 67.842c.74.37 1.641.07 2.012-.67.37-.742.07-1.643-.671-2.013l-1.342 2.683zm-11.31 6.905c.137.817.91 1.369 1.727 1.233.817-.137 1.369-.91 1.233-1.727l-2.96.494zm12.65-9.588c-3.515-1.759-7.024-1.202-9.49.802-2.432 1.975-3.746 5.27-3.16 8.786l2.96-.494c-.414-2.483.522-4.689 2.09-5.964 1.534-1.246 3.775-1.69 6.26-.447l1.34-2.683z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelOne);
export default __webpack_public_path__ + "static/media/Level_one.51d03ef481c5a37f2e2b1dcb84678639.svg";
export { ForwardRef as ReactComponent };